import { useNavigate } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { useQuickFiltersContext } from 'modules/expenses/components/expenses/PageContents/QuickFiltersContext'
import { MyExpensesDataCollection } from 'modules/expenses/components/my_expenses/DataCollection/MyExpensesDataCollection'
import { MyExpensesDataTable } from 'modules/expenses/components/my_expenses/Datatable'
import { useExpensesListPage } from 'modules/expenses/hooks/useExpensesListPage'
import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

import { useMyExpenses } from './MyExpensesContext'

const MyExpensesListTab = () => {
  const { employee } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { filters } = useQuickFiltersContext()
  const { company } = useCurrentSession()
  const { dateFilters } = usePageDateFilters()
  const {
    featureAvailabilities: { dataCollectionEnabled },
  } = useMyExpenses()

  const {
    categories,
    subcategories,
    canSeeTransactions,
    hasExpensesReportOnBehalfFeature,
    loading,
    recommendationsEnabled,
  } = useExpensesListPage({ companyId: company.id, skipProjectsQuery: true })

  // My Expenses doesn't support payroll reimbursement - use defaults
  // TODO: Remove when we will fully migrate to DataCollection
  const availableCategories: string[] = []
  const currentPeriodOpen = false

  if (!employee) {
    navigate(navigation.myExpenses.list.expenses.fullPath())
    return null
  }

  if (loading) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Spinner />
      </Box>
    )
  }

  return dataCollectionEnabled ? (
    <MyExpensesDataCollection
      companyId={company.id}
      employeeId={employee.id}
      back={{ href: navigation.myExpenses.list.expenses.fullPath() }}
      canSeeTransactions={canSeeTransactions}
      hasReportOnBehalfFeature={hasExpensesReportOnBehalfFeature}
      recommendationsEnabled={recommendationsEnabled}
    />
  ) : (
    <MyExpensesDataTable
      companyId={company.id}
      key={JSON.stringify(filters)} //re-mount the datatable if expensable search params change
      subcategories={subcategories}
      currentPayrollPeriodOpen={currentPeriodOpen}
      availablePayrollCategories={availableCategories || []}
      categories={categories}
      employeeIds={[employee?.id]}
      back={{ href: navigation.myExpenses.list.expenses.fullPath() }}
      hasReportOnBehalfFeature={hasExpensesReportOnBehalfFeature}
      canSeeTransactions={canSeeTransactions}
      dateFilters={dateFilters}
      recommendationsEnabled={recommendationsEnabled}
    />
  )
}

export default MyExpensesListTab
